export default __webpack_public_path__ + "static/media/youtube-footer.45e96f76.svg";